import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import KeyBenefits from "./sections/KeyBenefits";
import Hero from "./sections/Hero";
import FlexibleLayout from "./sections/FlexibleLayout";
import DemoShowcase from "./sections/DemoShowcase";
import KeyFeatures from "./sections/KeyFeatures";
import OurAgents from "./sections/OurAgents";
import PricingPlans from "./sections/PricingPlans";
import Testimonials from "./sections/Testimonials";
import ContactCallToAction from "./sections/ContactCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <KeyBenefits />
      <Hero />
      <FlexibleLayout />
      <DemoShowcase />
      <KeyFeatures />
      <OurAgents />
      <PricingPlans />
      <Testimonials />
      <ContactCallToAction />
      <Footer />
    </div>;
}